document.addEventListener("alpine:init", () => {
  Alpine.store("mobileDrawer", {
    isOpen: false,
    open() {
      this.isOpen = true;

      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      document.body.classList.add('mobile-drawer-open');
      window.dispatchEvent(new Event('mobile-drawer:open'));

    },
    close() {
      this.isOpen = false;
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.classList.remove('mobile-drawer-open');
    },
    toggle() {
      this.isOpen ? this.close() : this.open();
    },
  });
  Alpine.store("submenu", {
    isOpen: false,
    activeItem: null, // active header menu item
    activeCollapse: "baby-monitors", // active collapse item

    open(handle) {
      this.isOpen = true;
      this.activeItem = handle;
    },

    close() {
      this.isOpen = false;
      this.activeItem = null;
      this.activeCollapse = "baby-monitors";
    },

    openCollapse(handle) {
      this.activeCollapse = handle;
    },

    closeCollapse() {
      this.activeCollapse = null;
    },

    isActiveMenu(handle) {
      return this.isOpen && this.activeItem === handle;
    },
  });
});

// Custom Swiper
(function () {
  const PLAY_ICON = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M19 10.2679C20.3333 11.0377 20.3333 12.9623 19 13.7321L10 18.9282C8.66667 19.698 7 18.7358 7 17.1962L7 6.80385C7 5.26425 8.66667 4.302 10 5.0718L19 10.2679Z" fill="#363C45"/>
    </svg>
  `
  const PAUSE_ICON = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M8 19C9.1 19 10 18.1 10 17V7C10 5.9 9.1 5 8 5C6.9 5 6 5.9 6 7V17C6 18.1 6.9 19 8 19ZM14 7V17C14 18.1 14.9 19 16 19C17.1 19 18 18.1 18 17V7C18 5.9 17.1 5 16 5C14.9 5 14 5.9 14 7Z" fill="#363C45"/>
    </svg>
  `

  // 初始化Swiper
  function initSwiperSlideshow(root = document) {
    root.querySelectorAll('.custom-swiper').forEach((el) => {
      if (el.swiper) return
      const isAutoPlay = el.dataset.autoplay === 'true'
      const autoplayDelay = Number(el.dataset.speed) || 5000
      const loop = el.dataset.loop === 'true'
      const spaceBetween = Number(el.dataset.spacebetween)
      const isSingleSlide = el.dataset.issingleslide === 'true'
      const centeredSlides = el.dataset.centeredslides === 'true'
      const autoHeight = el.dataset.autoheight === 'true'

      const swiperConfig = {
        spaceBetween: spaceBetween,
        autoHeight: autoHeight,
        loop: loop,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        centeredSlides: centeredSlides,
      }

      if (isAutoPlay) {
        swiperConfig.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
        }
        el.style.setProperty('--autoplay-speed', `${autoplayDelay}ms`)
      }

      if (isSingleSlide) {
        swiperConfig.slidesPerView = 1
        swiperConfig.effect = 'fade'
      } else {
        swiperConfig.slidesPerView = 'auto'
      }


      let breakpoints

      try {
        breakpoints = el.dataset.breakpoints
          ? JSON.parse(el.dataset.breakpoints)
          : undefined
        swiperConfig.breakpoints = breakpoints
      } catch (e) {
        console.warn('Invalid breakpoints JSON', e)
      }

      const swiper = new Swiper(el, swiperConfig)
      const controlBtn = el.querySelector('.control')

      el.addEventListener('click', (e) => {
        const slideMedia = e.target.closest('.slide-media')
        if (!slideMedia || !el.contains(slideMedia)) return
        toggleAutoplay(el, swiper)
      })

      if (controlBtn) {
        controlBtn.addEventListener('click', (e) => {
          e.stopPropagation()
          toggleAutoplay(el, swiper)
        })
      }

      swiper.on('slideChange', () => {
        swiper.el.classList.remove('is-paused')
        if (controlBtn) controlBtn.innerHTML = PAUSE_ICON
      })

      swiper.on('slideChangeTransitionStart', () => {
        if (el.classList.contains('is-paused')) {
          el.classList.remove('is-paused')
          swiper.autoplay?.start()
        }
      })

      // Debug用，顯示每個slide的自定義播放時間
      // swiper.slides.forEach((slide, index) => {
      //   console.log(
      //     `Slide ${index}:`,
      //     slide.getAttribute('data-swiper-autoplay')
      //   )
      // })
      // console.log('swiperConfig:', swiperConfig)
    })
  }

  // 暫停與播放功能
  function toggleAutoplay(el, swiper) {
    if (!swiper.autoplay) return
    const controlBtn = el.querySelector('.control')
    const isPaused = el.classList.contains('is-paused')
    if (isPaused) {
      swiper.autoplay.start()
      el.classList.remove('is-paused')
      if (controlBtn) controlBtn.innerHTML = PAUSE_ICON
    } else {
      swiper.autoplay.stop()
      el.classList.add('is-paused')
      if (controlBtn) controlBtn.innerHTML = PLAY_ICON
    }
  }

  // 全站初始
  document.addEventListener('DOMContentLoaded', () => {
    initSwiperSlideshow()
  })

  // Shopify section reload
  document.addEventListener('shopify:section:load', (e) => {
    initSwiperSlideshow(e.target)
  })

  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('.custom-swiper').forEach((el) => {
      if (el.swiper) {
        el.swiper.destroy(true, true)
      }
    })
  })

  // 暴露給其他地方用
  window.initSwiperSlideshow = initSwiperSlideshow
})()
